import React, { FC } from "react";
import { Button, Modal, Spin } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { WorkplanExportPreviewModalBody } from "./modal-body";
import { Workplan } from "../../data-types";
import styles from "./modal.css";

const { ["workplan-modal"]: modalBody } = styles as any;

export type WorkplanExportPreviewModalProps = {
  show: boolean;
  loading: boolean;
  downloading: boolean;
  workplan?: Workplan;
  onCancel: () => void;
  onDownload: () => void;
};

export const WorkplanExportPreviewModal: FC<WorkplanExportPreviewModalProps> = ({
  show,
  loading,
  downloading,
  workplan,
  onCancel,
  onDownload,
}) => {
  return (
    <Modal
      className={modalBody}
      title="Workplan Preview"
      visible={show}
      width="90%"
      style={{ top: "48px" }}
      onCancel={onCancel}
      bodyStyle={{
        padding: "0",
        maxHeight: "70vh",
        overflowY: "scroll",
        backgroundColor: "gray",
      }}
      destroyOnClose={true}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="download"
          type="primary"
          icon={<DownloadOutlined />}
          loading={downloading}
          disabled={downloading}
          onClick={onDownload}
        >
          Download
        </Button>,
      ]}
    >
      <div className={""}>
        {loading ? (
          <Spin size="large" tip="Loading..." />
        ) : (
          workplan && <WorkplanExportPreviewModalBody workplan={workplan} />
        )}
      </div>
    </Modal>
  );
};
